import React from "react";
import { MessageCircle } from "lucide-react";
import { siteConfig } from "../mock";
import { openExternal } from "../lib/external";

const WhatsAppButton = () => {
  return (
    <a
      href={siteConfig.whatsapp}
      onClick={openExternal(siteConfig.whatsapp)}
      aria-label="Contacta-nos no WhatsApp"
      className="fixed bottom-6 right-6 z-40 group cursor-pointer"
    >
      <div className="relative">
        <span className="absolute inset-0 rounded-full bg-ember-400 animate-ping opacity-25" />
        <div className="relative w-14 h-14 rounded-full bg-gradient-to-br from-ember-400 to-ember-600 hover:from-ember-500 hover:to-ember-700 shadow-lg flex items-center justify-center text-white transition-colors">
          <MessageCircle className="w-6 h-6" />
        </div>
      </div>
    </a>
  );
};

export default WhatsAppButton;
